import { ComponentType } from "react";

export const LoadingText: ComponentType<{}> = () => {
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      Loading...
    </div>
  );
};
